module.exports = {
  SAVE_ASSET_TYPE: 'SAVE_ASSET_TYPE',
  SET_ASSET_TYPE: 'SET_ASSET_TYPE',
  RESET_ASSET_TYPE: 'RESET_ASSET_TYPE',
};
